import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DirtyTrackingService } from './dirty-tracking.service';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<any> {

    constructor(private dirtyService: DirtyTrackingService) {
    }

    canDeactivate(component: any,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | boolean {
        return from(this.dirtyService.isClean());
    }
}